import { render, staticRenderFns } from "./TopContentsTable.vue?vue&type=template&id=70fe5bcc&scoped=true&"
import script from "./TopContentsTable.vue?vue&type=script&lang=js&"
export * from "./TopContentsTable.vue?vue&type=script&lang=js&"
import style0 from "./TopContentsTable.vue?vue&type=style&index=0&id=70fe5bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe5bcc",
  null
  
)

export default component.exports